"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAffiliateBonuses = void 0;
var next_intl_1 = require("next-intl");
var Lockr = __importStar(require("lockr"));
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var CURRENT_CURRENCY = 'current_currency_by_type';
var CURRENT_LANG = 'current_lang';
var storageKey = 'affiliate';
var useAffiliateBonuses = function () {
    var _a, _b, _c;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _d = (0, useCache_1.useCache)(), getDataFromCache = _d.getDataFromCache, setDataToCache = _d.setDataToCache;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var affiliateData = typeof window !== 'undefined' && typeof localStorage !== 'undefined'
        ? Lockr.get(storageKey)
        : null;
    var offerId = (_a = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _a === void 0 ? void 0 : _a.offerId;
    var partnerId = (_b = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _b === void 0 ? void 0 : _b.partnerId;
    var partnerType = (_c = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _c === void 0 ? void 0 : _c.type;
    var _e = (0, useQuery_1.useQuery)({
        canRender: !!offerId && !!partnerId && !!partnerType,
        path: keys_1.AFFILIATE_BONUS,
        payload: {
            offerId: Number(offerId),
            partnerId: Number(partnerId),
            currency: currentCurrency,
            lang: lang,
            partnerType: partnerType,
        },
        revalidateOnMount: true,
        shouldRetryOnError: false,
    }), data = _e.data, error = _e.error, isLoading = _e.isLoading, mutate = _e.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
        }
    }, [lang, getDataFromCache, setDataToCache, currentCurrency, mutate]);
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            data: ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.bonuses) || [],
            isLoading: isLoading,
            error: error,
        });
    }, [data, isLoading, error]);
};
exports.useAffiliateBonuses = useAffiliateBonuses;
